//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Rectangle from './Rectangle.vue'

export default {
  components: { Rectangle },
  props: {
    routeSource: {
      type: Object,
      default: null
    }
  },
  computed: {
    blackAndYellowRegistered: function () {
      return this.getChildrenBlockByType('blackAndYellowRegistered')
    },
    blackAndYellowExecuted: function () {
      return this.getChildrenBlockByType('blackAndYellowExecuted')
    },
    blackAndYellowInWork: function () {
      return this.getChildrenBlockByType('blackAndYellowInWork')
    }
  },
  methods: {
    getChildrenBlockByType: function (type) {
      const routeSourceChildrens = this.routeSource && this.routeSource.compound && this.routeSource.compound.flatMap(compound => compound.children)
      return routeSourceChildrens && routeSourceChildrens.find(children => children.type === type)
    }
  }
}
